module.exports = __webpack_public_path__ + "e0ab722e508e1c05cc52acd1e7b3af38.svg";